(() => {
  const init = (root) => {
    const trigger = root.querySelector('[data-hps-thermal-trigger]');
    const viewer = root.querySelector('[data-hps-image-viewer]');
    const stage = root.querySelector('[data-hps-image-viewer-stage]');
    const close = root.querySelector('[data-hps-image-viewer-close]');
    const image = stage?.querySelector('img');
    if (!trigger || !viewer || !stage || !close || !image || viewer.dataset.ready === 'true') return;
    viewer.dataset.ready = 'true';
    let zoom = 1;
    const render = () => { image.style.transform = `scale(${zoom})`; };
    const reset = () => { zoom = 1; render(); };
    const dismiss = () => { if (viewer.open) viewer.close(); reset(); };
    trigger.addEventListener('click', () => { reset(); viewer.showModal(); });
    close.addEventListener('click', dismiss);
    viewer.addEventListener('click', (event) => { if (event.target === viewer) dismiss(); });
    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      zoom = Math.min(3, Math.max(1, zoom + (event.deltaY < 0 ? .14 : -.14)));
      render();
    }, { passive: false });
    viewer.addEventListener('close', reset);
  };
  const boot = () => document.querySelectorAll('[data-hc-product-story]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
